import {
  cn,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@up2stay/up2promo-ui';
import { ArrowUpDown } from 'lucide-react';

import { listToolbarFilterButtonClass } from '@/core/components/layout/list-toolbar-styles';

export type ListSortOption<T extends string> = {
  value: T;
  label: string;
};

export type ListSortSelectProps<T extends string> = {
  value: T;
  onChange: (next: T) => void;
  options: ReadonlyArray<ListSortOption<T>>;
  /** Accessible name / placeholder for the trigger. */
  ariaLabel: string;
  triggerClassName?: string;
  contentAlign?: 'start' | 'center' | 'end';
};

/**
 * Shared list-page sort Select. Feature modules supply options + labels only.
 */
export function ListSortSelect<T extends string>({
  value,
  onChange,
  options,
  ariaLabel,
  triggerClassName,
  contentAlign = 'end',
}: ListSortSelectProps<T>) {
  return (
    <Select value={value} onValueChange={(next) => onChange(next as T)}>
      <SelectTrigger
        aria-label={ariaLabel}
        className={cn(
          listToolbarFilterButtonClass,
          'min-w-0 justify-between gap-2',
          triggerClassName,
        )}
      >
        <ArrowUpDown className="h-4 w-4 shrink-0 text-muted-foreground" />
        <SelectValue
          placeholder={ariaLabel}
          className="min-w-0 flex-1 truncate text-left"
        />
      </SelectTrigger>
      <SelectContent align={contentAlign}>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
